import { StoreSetting } from '@/types/setting-type';
import { format } from 'date-fns';

interface ReceiptHeaderProps {
  company: StoreSetting;
  date: Date | string;
  receiptNo: string;
}

export function ReceiptHeader({ company, date, receiptNo }: ReceiptHeaderProps) {
  return (
    <div className="receipt-header  text-xs font-bold">
      <div className="px-3 pt-2.5 pb-2">
        <div className="flex items-center gap-2 mb-0.5">
          {company.logo ? (
            <img
              src={company.logo}
              alt={company.name}
              className="receipt-logo h-8 w-8 object-contain shrink-0"
            />
          ) : (
            <div className="receipt-logo h-8 w-8 rounded bg-slate-100 grid place-items-center text-slate-500 text-xs  shrink-0">
              {company.name?.[0] ?? 'S'}
            </div>
          )}

          <div className="flex-1 min-w-0">
            <div className="receipt-company-name text-xs  mb-0.5 text-black leading-tight">
              {company.name}
            </div>
            <div className="receipt-company-details text-xs leading-tight space-y-0.5">
              {/* {company.addressLine1 && <div>{company.addressLine1}</div>}
              {company.addressLine2 && <div>{company.addressLine2}</div>} */}
              {(company.phone) && (
                <div>
                  {company.phone && <span>Tel: {company.phone}</span>}
                  {/* {company.phone && company.email && <span> • </span>}
                  {company.email && <span>{company.email}</span>} */}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="receipt-meta pt-1.5 flex items-center justify-between text-xs">
          <div className="flex items-center gap-1">
            <span>#{receiptNo}</span>
          </div>
          <div className="flex items-center gap-1">
            <span>{format(date, 'yyyy MMM dd')}</span> | 
            <span>{format(date, 'hh:mm a')}</span>
          </div>
        </div>
      </div>
      <div className="border-b border-black"></div>
    </div>
  );
}
